import { isFolderItem } from "./isFolderItem.js";
import { isNullItem } from "./isNullItem.js";
/**
 * Set the checked prop of the given items to true if they are checked
 * @param items
 * @param checkedKey
 * @return boolean if at least one checked item was found
 */
export function markCheckedItems(items, checkedKey) {
  return items.map(item => {
    if (isNullItem(item)) {
      return false;
    }
    if (isFolderItem(item)) {
      item.checked = markCheckedItems(item.elements, checkedKey);
    } else {
      item.checked = item.key === checkedKey;
    }
    return item.checked ?? false;
  }).includes(true);
}